module.exports = __webpack_public_path__ + "img/frase_brincadeiras.756e410d.svg";